import Vue from "vue";
import {
  SET_SANTE_STEP,
  SET_SANTE_PHASE,
  SET_SANTE_SUBMISSION_REF,
  SET_SANTE_ACTIVE_AFFILIATION,
  SET_SANTE_ADHERENT_FIELD,
  SET_SANTE_AFFILIATION_FIELD,
  TOGGLE_SANTE_AFFLICTION,
  SET_SANTE_AFFLICTION_AUTRE,
  ADD_SANTE_MEDICATION,
  REMOVE_SANTE_MEDICATION,
  ADD_SANTE_AFFILIATION,
  REMOVE_SANTE_AFFILIATION,
  SET_SANTE_DECLARATION_NAME,
  SET_SANTE_DECLARATION_ACCEPTED,
  SET_SANTE_CONSENT_DATA,
  SET_SANTE_FILE,
  SET_SANTE_ERRORS,
  SET_SANTE_ERROR,
  CLEAR_SANTE_ERRORS,
  SET_SANTE_LOADING,
  RESET_SANTE,
} from "./mutation-types";
import { buildEmptyState, buildInsured } from "./state";

/** Résout la personne (adhérent | affilié) à partir d'un `target`. */
function resolvePerson(state, target) {
  if (target === "adherent") return state.form.adherent;
  if (typeof target === "number") return state.form.affiliations[target];
  return null;
}

export default {
  [SET_SANTE_STEP](state, step) {
    state.currentStep = step;
  },
  [SET_SANTE_PHASE](state, phase) {
    state.appPhase = phase;
  },
  [SET_SANTE_SUBMISSION_REF](state, ref) {
    state.submissionRef = ref;
  },
  [SET_SANTE_ACTIVE_AFFILIATION](state, index) {
    state.activeAffiliationIndex = index;
  },

  // ── Champs identité ──
  [SET_SANTE_ADHERENT_FIELD](state, { key, value }) {
    Vue.set(state.form.adherent, key, value);
  },
  [SET_SANTE_AFFILIATION_FIELD](state, { index, key, value }) {
    Vue.set(state.form.affiliations[index], key, value);
  },

  // ── Questionnaire médical ──
  [TOGGLE_SANTE_AFFLICTION](state, { target, code }) {
    const p = resolvePerson(state, target);
    if (!p) return;
    const arr = p.afflictionCodes || [];
    const idx = arr.indexOf(code);
    if (idx >= 0) {
      arr.splice(idx, 1);
      if (code === "AUTRE") p.afflictionAutre = "";
    } else {
      arr.push(code);
    }
    Vue.set(p, "afflictionCodes", [...arr]);
  },
  [SET_SANTE_AFFLICTION_AUTRE](state, { target, value }) {
    const p = resolvePerson(state, target);
    if (p) Vue.set(p, "afflictionAutre", value);
  },
  [ADD_SANTE_MEDICATION](state, { target, value }) {
    const p = resolvePerson(state, target);
    if (!p) return;
    const clean = (value || "").trim();
    if (!clean) return;
    const exists = p.medications.some(
      (m) => m.toLowerCase() === clean.toLowerCase()
    );
    if (!exists) Vue.set(p, "medications", [...p.medications, clean]);
  },
  [REMOVE_SANTE_MEDICATION](state, { target, index }) {
    const p = resolvePerson(state, target);
    if (!p) return;
    const arr = [...p.medications];
    arr.splice(index, 1);
    Vue.set(p, "medications", arr);
  },

  // ── Affiliés ──
  [ADD_SANTE_AFFILIATION](state, type) {
    const aff = buildInsured(type || "enfant");
    state.form.affiliations.push(aff);
    state.errors.affiliations.push({});
    state.activeAffiliationIndex = state.form.affiliations.length - 1;
  },
  [REMOVE_SANTE_AFFILIATION](state, index) {
    const removed = state.form.affiliations[index];
    if (removed && state.files[removed.id]) {
      Vue.delete(state.files, removed.id);
    }
    state.form.affiliations.splice(index, 1);
    state.errors.affiliations.splice(index, 1);
    state.activeAffiliationIndex = Math.min(
      state.activeAffiliationIndex,
      Math.max(0, state.form.affiliations.length - 1)
    );
  },

  // ── Déclaration ──
  [SET_SANTE_DECLARATION_NAME](state, value) {
    state.form.declarationName = value;
  },
  [SET_SANTE_DECLARATION_ACCEPTED](state, value) {
    state.form.declarationAccepted = value;
  },
  [SET_SANTE_CONSENT_DATA](state, value) {
    state.form.consentData = value;
  },

  // ── Fichiers (photo | acte) par id de personne ──
  [SET_SANTE_FILE](state, { personId, kind, file }) {
    const current = state.files[personId] || { photo: null, acte: null };
    Vue.set(state.files, personId, { ...current, [kind]: file });
  },

  // ── Erreurs ──
  [SET_SANTE_ERRORS](state, { section, errors, index }) {
    if (section === "affiliation" && typeof index === "number") {
      Vue.set(state.errors.affiliations, index, errors);
    } else {
      Vue.set(state.errors, section, errors);
    }
  },
  [SET_SANTE_ERROR](state, { key, message }) {
    Vue.set(state.errors, key, message);
  },
  [CLEAR_SANTE_ERRORS](state) {
    state.errors = {
      adherent: {},
      affiliations: state.form.affiliations.map(() => ({})),
      declaration: "",
      submit: "",
    };
  },

  [SET_SANTE_LOADING](state, { key, value }) {
    Vue.set(state.loading, key, value);
  },

  [RESET_SANTE](state) {
    Object.assign(state, buildEmptyState());
  },
};
